import { libTypes } from "@holta/lib";
import {createAction} from "../fns/createAction";


export const setOrdersSearch = createAction("SET_ORDERS_SEARCH", (newState, orders: libTypes.Order[]) => {
    newState.ordersSearch = orders;
});